/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobToDateQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TemplateJobToDateQueryOperator");
    }

    getFixupPrototypeFunction() { return TemplateJobToDateQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobToDateQueryOperator>): TemplateJobToDateQueryOperator {
        let obj = Object.assign(new TemplateJobToDateQueryOperator(), model);
        TemplateJobToDateQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobToDateQueryOperator>): TemplateJobToDateQueryOperator {
        if (!model) return null;
        return TemplateJobToDateQueryOperator.newInstance(<TemplateJobToDateQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobToDateQueryOperator) {
        if (!obj) return;

        models.TemplateJobToDateQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobToDateQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobToDateQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.to_date === "string") {
            this.to_date = new Date(<string><any>this.to_date);
        }
    }

    /**
     * Include jobs created on or before this date
     */
    to_date: Date;

}
